export interface SaveStationDeviceLicenseKeySuccessResponse {
    device_id: number;
    license_key: string;
}

export interface SaveStationDeviceLicenseKeyFailResponse {
    device_id: number;
    error_message: string;
}

export class SaveStationDeviceLicenseKeySuccess {
    constructor(public readonly deviceId: number, public readonly licenseKey: string) {}
}

export class SaveStationDeviceLicenseKeyFail {
    constructor(public readonly deviceId: number, public readonly errorMessage: string) {}
}
